import { Avatar } from '@affine/component';
import { CloudDocMetaService } from '@affine/core/modules/cloud/services/cloud-doc-meta';
import { WorkspaceFlavour } from '@affine/env/workspace';
import { useI18n } from '@affine/i18n';
import { useLiveData, useService, WorkspaceService } from '@toeverything/infra';
import { useEffect, useMemo } from 'react';

import * as styles from './created-updated-by.css';

const CloudUserAvatar = (props: { type: 'CreatedBy' | 'UpdatedBy' }) => {
  const cloudDocMetaService = useService(CloudDocMetaService);
  const cloudDocMeta = useLiveData(cloudDocMetaService.cloudDocMeta.meta$);
  const isRevalidating = useLiveData(
    cloudDocMetaService.cloudDocMeta.isRevalidating$
  );
  const error = useLiveData(cloudDocMetaService.cloudDocMeta.error$);

  useEffect(() => {
    cloudDocMetaService.cloudDocMeta.revalidate();
  }, [cloudDocMetaService]);

  const user = useMemo(() => {
    if (!cloudDocMeta) return null;
    if (props.type === 'CreatedBy' && cloudDocMeta.createdBy) {
      return {
        name: cloudDocMeta.createdBy.name,
        avatarUrl: cloudDocMeta.createdBy.avatarUrl,
      };
    } else if (props.type === 'UpdatedBy' && cloudDocMeta.updatedBy) {
      return {
        name: cloudDocMeta.updatedBy.name,
        avatarUrl: cloudDocMeta.updatedBy.avatarUrl,
      };
    }
    return null;
  }, [cloudDocMeta, props.type]);

  if (!cloudDocMeta) {
    if (isRevalidating) {
      // TODO: loading ui
      return null;
    }
    if (error) {
      // error ui
      return;
    }
    return null;
  }
  if (user) {
    return (
      <>
        <Avatar url={user.avatarUrl || ''} name={user.name} size={20} />
        <span>{user.name}</span>
      </>
    );
  }
  return <NoRecordValue />;
};

const NoRecordValue = () => {
  const t = useI18n();
  return (
    <span>
      {t['com.affine.doc-properties.property-user-avatar-no-record']()}
    </span>
  );
};

const LocalUserValue = () => {
  const t = useI18n();
  return <span>{t['com.affine.doc-properties.local-user']()}</span>;
};

export const CreatedUserValue = () => {
  const workspaceService = useService(WorkspaceService);
  const isCloud =
    // DNB_NEW_NAMES_FIX
    workspaceService.workspace.flavour === WorkspaceFlavour.DNB_CLOUD;

  if (!isCloud) {
    return (
      <div className={styles.propertyRowValueUserCell}>
        <LocalUserValue />
      </div>
    );
  }

  return (
    <div className={styles.propertyRowValueUserCell}>
      <CloudUserAvatar type="CreatedBy" />
    </div>
  );
};

export const UpdatedUserValue = () => {
  const workspaceService = useService(WorkspaceService);
  const isCloud =
    // DNB_NEW_NAMES_FIX
    workspaceService.workspace.flavour === WorkspaceFlavour.DNB_CLOUD;

  if (!isCloud) {
    return <LocalUserValue />;
  }

  return (
    <div className={styles.propertyRowValueUserCell}>
      <CloudUserAvatar type="UpdatedBy" />
    </div>
  );
};
